import 'bootstrap'
import '../styles/Toaster.scss'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-toastify/dist/ReactToastify.css'
import '../styles/App.scss'
import DropzoneContext from '../contexts/DropzoneContext'
import Search from './Search'
import FolderContext from '../contexts/FolderContext'
import NavBar from './NavBar'
import PropTypes from 'prop-types'
import React, { PureComponent, createRef, lazy, Suspense, createContext } from 'react'
import UserContext from '../contexts/UserContext'
import produce from 'immer'
import routes from '../routes'
import { Query } from '@apollo/react-components'
import { Route, Switch, Redirect } from 'react-router-dom'
import { Slide, ToastContainer } from 'react-toastify'
import { withRouter } from 'react-router'
import UsgsHeader from './UsgsHeader'
import UsgsFooter from './UsgsFooter'
import ScienceBaseFooter from './ScienceBaseFooter'
import Item from './item/Item'
import HomePage from './HomePage'
import DownloadFile from './DownloadFile'
import gql from 'graphql-tag'
import Splash from './Splash'

const Buckets = lazy(() => import('./buckets/Buckets'))
const Admin = lazy(() => import('./admin/Admin'))

const GET_CURRENT_USER_AND_MAJOR_FOLDERS = gql`
query GetCurrentUserAndMajorFolders {
  me {
    username
    roles
  }
}

`

export const AppNavContext = createContext()

// returnToId (from incoming uURL from SB2)
let search = window.location.search
let params = new URLSearchParams(search)
const returnToId = params.get('returnToId')

class App extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      dropRef: createRef(),
      currentFolder: {
        id: null,
        path: null,
        item: {
          fullAncestors: [],
        },
        returnToId: null,
        ancestors: [],
        set: ({ id, path, item }) => {
          this.setState(produce(draft => {
            draft.currentFolder.id = id
            draft.currentFolder.path = path
            draft.currentFolder.item = item
          }))
        },
      }
    }
  }

  render() {
    return (
      <Query query={GET_CURRENT_USER_AND_MAJOR_FOLDERS}
        fetchPolicy="cache-and-network"
      >
        {({ data: { me, majorFolders } = {}, loading }) => {
          const isAdmin = me && me.roles ? me.roles.includes('ScienceBase_SystemAdmin') : false

          if (me) {
            return (
              <AppNavContext.Provider value={ { majorFolders: majorFolders, returnToId: returnToId } }>
                <UserContext.Provider value={ me }>
                  <div className="wrapper">
                    {/* <span id="sb-env-banner">SB3-Preview</span> */}
                    <UsgsHeader />
                    <FolderContext.Provider value={this.state.currentFolder}>
                      <DropzoneContext.Provider value={this.state.dropRef}>
                        <NavBar admin={isAdmin}/>

                        <Suspense fallback={<div>Loading...</div>}>
                          <Switch>
                            <Route exact path='/' component={Splash} />
                            <Route exact path='/manager' component={HomePage} />
                            <Route exact path='/home' component={Splash} />
                            {/* <Route path='/admin' component={Admin} /> */}
                            <Route path={`${routes.bucketsPath}`} component={Buckets} />
                            {/* <Route path='/search' render={(props) => <Search {...props} token={this.state.token} />} /> */}
                            <Route path={`${routes.itemPath}/:id`} component={Item} />
                            <Route path={`${routes.downloadFile}/:cuid`} component={DownloadFile} />
                            {/* <Redirect exact from='/myFolder' to={`${routes.itemPath}/${me.myFolder.id}`} /> */}
                          </Switch>
                        </Suspense>
                      </DropzoneContext.Provider>
                    </FolderContext.Provider>
                    <ToastContainer transition={Slide} position="top-center" className='toast-container' />
                    <div id="footer-wrapper">
                      <ScienceBaseFooter />
                      <UsgsFooter/>
                    </div>
                  </div>
                </UserContext.Provider>
              </AppNavContext.Provider>
            )
          } else if (loading) {
            return 'Loading'
          }
        }}
      </Query>
    )
  }
}

App.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }),
}

export default withRouter(App)
